import type { ReactElement } from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from '@front/model'
import { Page } from '@components'

function RolesPage(): ReactElement {
  const { t } = useTranslation()

  return (
    <Page>
      <Page.Hero
        icon='account_circle'
        title={t('Roles')}
        description={t('Select a role to edit its details, or add a new one.')}
      />
    </Page>
  )
}

export const Route = createFileRoute('/settings/role/')({
  component: RolesPage,
})
